import { FC } from 'react'

import { toast } from '$app/utilities'

import { Icon } from '@trustycars/genie-ui/icons/Icon'

import useSignal from '$actions/useSignal'

import { ProfilePhoto } from '$elements/ProfilePhoto'
import CenterLoader from '$elements/CenterLoader'
import VerifiedBadge from '$elements/VerifiedBadge'

import { clipboardCopyText, getPhone } from '$app/utilities'

import { profile } from '$store/profile'

import {
  profilePhotoFigure,
  accountIdTitle,
  accountIdValue,
  accountId,
  accountIdCopy,
  info,
  accountName,
  accountAlias,
  container
} from './styles.css'

export const AccountInfo: FC = () => {
  const profileStore = useSignal(profile)

  const {
    name,
    phone_code,
    phone_no,
    email,
    id,
    profile_photo_url,
    is_phone_verified,
    is_email_verified
  } = {
    ...profileStore?.data
  }
  const isLoading = !!profileStore?.loading

  const copyAccountID = () => {
    if (!id) return

    toast.promise(clipboardCopyText(`${id}`), {
      loading: 'Copying..',
      error: 'Failed to copy',
      success: 'Copied'
    })
  }

  const phone = getPhone({ phone_code, phone_no })

  return (
    <article data-testid="profile-info" className={container}>
      {isLoading ? (
        <CenterLoader />
      ) : (
        <>
          <ProfilePhoto
            src={profile_photo_url}
            className={profilePhotoFigure}
            isVerified={is_email_verified}
          />

          <header className={info}>
            {name && (
              <h4 data-testid="profile-name" className={accountName}>
                {name}
              </h4>
            )}

            {email && (
              <p data-testid="profile-email" className={accountAlias}>
                {email}
              </p>
            )}

            {phone && (
              <p data-testid="profile-phone" className={accountAlias}>
                {phone}
              </p>
            )}

            <div style={{ marginTop: 6, display: 'flex', gap: 5 }}>
              {!!email && (
                <VerifiedBadge
                  is_verified={is_email_verified}
                  verifiedText="Email Verified"
                  unVerifiedText="Email Unverified"
                />
              )}

              {!!phone && (
                <VerifiedBadge
                  is_verified={is_phone_verified}
                  verifiedText="Phone Verified"
                  unVerifiedText="Phone Unverified"
                />
              )}
            </div>
          </header>

          <div className={accountId}>
            <h4 className={accountIdTitle}>User ID</h4>

            <p className={accountIdValue} data-testid="profile-account-id">
              #{id}
            </p>

            <button
              title="Copy User ID"
              type="button"
              className={accountIdCopy}
              onClick={copyAccountID}
            >
              <Icon namespace="Copy" />
            </button>
          </div>
        </>
      )}
    </article>
  )
}

export default AccountInfo
